import React from "react";
import { Form } from "antd";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import CourtCaseConnectionTypeForm from "./CourtCaseConnectionTypeForm";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import { ICourtCaseConnectionType } from "../../model/CourtCaseConnectionType";
import TickBox from "../../../core/ui/components/grid/TickBox";

interface CourtCaseConnectionTypeGridGridProps {
  translate: any;
  courtCaseConnectionTypeList: ICourtCaseConnectionType[];
  createCourtCaseConnectionType: any;
  referenceLoader?: boolean;
  updateCourtCaseConnectionType;
}
const CourtCaseGrid: React.FC<CourtCaseConnectionTypeGridGridProps> = ({
  translate,
  courtCaseConnectionTypeList,
  createCourtCaseConnectionType,
  referenceLoader,
  updateCourtCaseConnectionType
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.court_case_connection_type"
  });
  const columns = builder.buildColumns(
    {
      name: "name",
      dataKey: "name"
    },
    {
      name: "valid",
      dataKey: "valid",
      sortable: false,
      align: "center",
      render: (record) => <TickBox value={record.valid} />
    }
  );

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      title={translate("editors.court_case_connection_type.title")}
      columns={columns}
      translate={translate}
      dataSource={courtCaseConnectionTypeList || []}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate(
        "editors.court_case_connection_type.add_new_text"
      )}
      createForm={
        <CourtCaseConnectionTypeForm translate={translate} form={CreateForm} />
      }
      updateForm={
        <CourtCaseConnectionTypeForm translate={translate} form={UpdateForm} />
      }
      createModalTitle={`${translate(
        "editors.court_case_connection_type.create_modal_title"
      )}`}
      updateModalTitle={`${translate(
        "editors.court_case_connection_type.update_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createCourtCaseConnectionType(e);
      }}
      onUpdate={updateCourtCaseConnectionType}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
    />
  );
};
export default CourtCaseGrid;
